module.exports = __webpack_public_path__ + "img/Invoice-amico.696d8362.png";